import { formatPhoneNumberIntl } from 'react-phone-number-input';

export const specialRound = (num) => {
  let calculated = '0';
  if (num >= 99.00) {
    [calculated] = num.toString().match(/^-?\d+(?:\.\d{0,2})?/);
  } else {
    calculated = num.toFixed(0);
  }
  return calculated;
};

export const phoneInternationalFormat = (phoneNumber) => {
  const internationalFormat = formatPhoneNumberIntl(
    phoneNumber
  ).toString();
  return internationalFormat;
};

export const validateAmount = (amount) => {
  const validformat = /^\d{0,7}(\.\d{1,2})?$/;
  const validValue = amount.replace(new RegExp(',', 'g'), '');
  return validformat.test(validValue);
};

export const parseAmountFloat = (amount) => {
  const tempAmount = amount.replace(
    new RegExp(',', 'g'),
    ''
  );
  return parseFloat(tempAmount);
};

export const parseAmountStr = (amount) => {
  const tempAmount = amount.replace(
    new RegExp(',', 'g'),
    ''
  );
  return String(tempAmount);
};

export const thousandSeparator = (amount) => {
  const thousandseparator = /^\d+(,\d{3})*(\.\d+)?$/;
  return thousandseparator.test(amount);
};

export const downloadAsPDF = (blob, filename) => {
  const url = window.URL.createObjectURL(
    new Blob([blob], { type: 'application/pdf' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    filename
  );
  document.body.appendChild(link);
  link.click();
};

export const processIC = (icNum) => {
  const replacedSymbol = icNum.replace(/-/g, '');
  const isnum = /^\d+$/.test(replacedSymbol);
  if (isnum) {
    const formattedIC = `${replacedSymbol.slice(0, 6)}-${replacedSymbol.slice(6, 8)}-${replacedSymbol.slice(8, 12)}`;
    return formattedIC;
  }
  return icNum;
};

export const parseGenderFromIC = (ICNum) => {
  const testGender = parseInt(ICNum.charAt(ICNum.length - 1), 10) % 2;
  switch (testGender) {
    case 0:
      return 'F';
    case 1:
      return 'M';
    default:
      return '';
  }
};

export const getBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const normalizeCurrency = (value) => {
  if (!value) {
    return value;
  }
  const input = value;
  const parts = input.split('.');
  if (parts.length === 1) {
    return parts[0].replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const part1 = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  const part2 = parts[1];
  return `${part1}.${part2}`;
};

export const appendLocale = (variableName) => {
  const locale = localStorage.getItem('language');
  if (locale) {
    return `${variableName}_${locale}`;
  }
  else {
    return `${variableName}_th`;
  }
}